// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'dev',
   baseUrl: 'https://bsh-cspi.com/v1/api',
  // imageServerPath : 'http://localhost:8081/uploaded-assets/'
  // baseUrl: 'http://13.232.45.175/v1/api',
  imageServerPath : 'http://13.232.45.175/uploaded-assets/',
  firebaseConfig : {
    apiKey: "AIzaSyDUgLnFPtQsOxrKk7vtdB0qVTbz1yuJRNY",
    authDomain: "test-810b5.firebaseapp.com",
    databaseURL: "https://test-810b5.firebaseio.com",
    projectId: "test-810b5",
    storageBucket: "test-810b5.appspot.com",
    messagingSenderId: "742349471860",
    appId: "1:742349471860:web:141d240e4e0c2c4a7d1121",
    measurementId: "G-8H0CGRPG20"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
